'use client';

import React from 'react';
import Image from 'next/image';

interface Props {
  src: string;
  alt: string;
}

const FALLBACK = '/home/foto-home.webp';

export function HeroImage({ src, alt }: Props) {
  return (
    <Image
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = FALLBACK;
      }}
      width={322}
      height={415}
      className='ml-5 h-auto w-[120px] md:ml-0 md:w-[322px]'
      src={src}
      alt={alt}
      priority
      placeholder='empty'
    />
  );
}
